function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.url.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import YouTube from 'react-youtube';
import SuggestionProducts from '../../SuggestionProducts';
import SingleProductMobileAccordion from './SingleProductMobileAccordion';
import _orderBy from 'lodash/orderBy';
import _deburr from 'lodash/deburr';
import _compact from 'lodash/compact';
import { API_URL, LANG } from '../../utils/constant';
import { assetPath, excerpt, translate, translateFieldName, cleanHTML, getCartLocalStorage, setCartLocalStorage } from '../../utils/helpers';
import { FacebookShareButton, LinkedinShareButton } from 'react-share';
import { Services } from '../../utils/Services';
import striptags from 'striptags';
import BreadCrumbSingleProduct from '../BreadCrumbSingleProduct';

var SingleProductWoMatch = /*#__PURE__*/function (_Component) {
  _inherits(SingleProductWoMatch, _Component);

  var _super = _createSuper(SingleProductWoMatch);

  function SingleProductWoMatch(props) {
    var _this;

    _classCallCheck(this, SingleProductWoMatch);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "fetchProduct", function () {
      Services.fetchProduct(_this.props.slug).then(function (product) {
        if (product.error !== undefined) {
          window.location.href = '/404';
        } else {
          _this.setState({
            product: product
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateCart", function (product, quantity, variation, cart) {
      var _product = product;
      _product.quantity = quantity;
      _product.selectedVariation = variation === null ? {
        id: 0,
        noVariation: true,
        name_en: '',
        name_fr: ''
      } : variation;
      _product.uniqId = _product.id + '+uniq' + _product.selectedVariation.id;
      var _cart = cart;
      var index = cart.findIndex(function (item) {
        return item.uniqId === _product.uniqId;
      });

      if (index === -1) {
        _cart.push(_product);
      } else {
        _cart[index].quantity += quantity;
      }

      return _cart;
    });

    _defineProperty(_assertThisInitialized(_this), "addToCart", function () {
      _this.setState({
        disabled: true
      });

      var selectedIndex = _this.variationRef.current !== null ? _this.variationRef.current.selectedIndex : 0;

      var _variation = _this.state.product.formats.length ? _this.state.product.formats[selectedIndex] : null;

      var myCart = getCartLocalStorage();
      myCart = _this.updateCart(_this.state.product, parseInt(_this.quantityRef.current.value, 10), _variation, myCart);
      setCartLocalStorage(myCart);
      setTimeout(function () {
        if (_this._isMounted) _this.setState({
          disabled: false
        });
      }, 2000);
    });

    _defineProperty(_assertThisInitialized(_this), "updateInputValue", function (event) {
      _this.setState({
        inputValue: event.target.value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onChangeQuantity", function (event) {
      var inputValue = event.target.value; //return false if the value typed by user is not a number

      if (!event.target.validity.valid) {
        return false;
      } //return false if the value typed by user is superior to its max attribute


      if (parseInt(event.target.value, 10) > parseInt(event.target.max, 10)) {
        return false;
      }

      if (parseInt(event.target.value, 10) === 0) {
        inputValue = 1;
      }

      _this.setState({
        inputValue: inputValue
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setActiveSlide", function (activeSlide) {
      _this.setState({
        activeSlide: activeSlide
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setActiveProduct", function (activeProduct) {
      _this.setState({
        activeProduct: activeProduct,
        activeBackDrop: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeModal", function () {
      _this.setState({
        activeBackDrop: false
      });

      window.setTimeout(function () {
        $('#ModalAddToCart').modal('hide');
      }, 800);
    });

    _defineProperty(_assertThisInitialized(_this), "closeModalOut", function (e) {
      if (e.target.id === 'ModalAddToCart') {
        _this.setState({
          activeBackDrop: false
        });

        $('#ModalAddToCart').modal('hide');
      }
    });

    _this.state = {
      activeSlide: 0,
      activeBackDrop: false,
      activeProduct: {},
      product: {},
      inputValue: 1,
      disabled: false
    };
    _this._isMounted = false;
    _this.quantityRef = /*#__PURE__*/React.createRef();
    _this.variationRef = /*#__PURE__*/React.createRef();
    _this.youtubeOptions = {
      height: '390',
      width: '640',
      playerVars: {
        autoplay: 0,
        disabled: false,
        rel: 0,
        modestbranding: 1
      }
    };
    return _this;
  }

  _createClass(SingleProductWoMatch, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.querySelector(this.props.rootElement).classList.add('single-product');
      this.fetchProduct(); // this.setState({ product: this.props.product })
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this._isMounted = true;

      if (prevProps.product !== this.props.product) {
        this.fetchProduct();
        this.setState({
          inputValue: 1
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
      document.querySelector(this.props.rootElement).classList.remove('single-product');
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var product = this.state.product;

      if (product.id !== undefined) {
        var _product$related_ino_;

        var suggestionProducts = (_product$related_ino_ = product.related_ino_products) === null || _product$related_ino_ === void 0 ? void 0 : _product$related_ino_.concat(product.compatible_ino_products);
        return /*#__PURE__*/React.createElement("div", {
          className: "single-product"
        }, /*#__PURE__*/React.createElement("div", {
          className: "breadcrumbs-container"
        }, /*#__PURE__*/React.createElement("div", {
          className: "container"
        }, /*#__PURE__*/React.createElement(BreadCrumbSingleProduct, {
          product: product
        }))), /*#__PURE__*/React.createElement("div", {
          className: "single_product"
        }, /*#__PURE__*/React.createElement("div", {
          className: "row single-product-main-content"
        }, /*#__PURE__*/React.createElement("div", {
          className: "col-12 col-lg-6 py-3 medias align-items-center"
        }, /*#__PURE__*/React.createElement("div", {
          className: "container"
        }, /*#__PURE__*/React.createElement("div", {
          className: "description-title d-md-block d-lg-none"
        }, /*#__PURE__*/React.createElement("h1", {
          className: "uppercase"
        }, product[translateFieldName('code')]), /*#__PURE__*/React.createElement("h2", null, product[translateFieldName('name')])), /*#__PURE__*/React.createElement("div", {
          className: "description-text d-md-block d-lg-none"
        }, /*#__PURE__*/React.createElement("p", {
          className: "first-uppercase",
          dangerouslySetInnerHTML: {
            __html: cleanHTML(excerpt(product[translateFieldName('description')], 200))
          }
        })), /*#__PURE__*/React.createElement("div", {
          className: "medias-container"
        }, product.product_photos.length > 0 && this.state.activeSlide !== 99 ? /*#__PURE__*/React.createElement("div", {
          className: "product-image",
          style: product.product_photos[this.state.activeSlide].photo.medium.url !== null ? {
            backgroundImage: "url(".concat(assetPath(product.product_photos[this.state.activeSlide].photo.medium.url), ")")
          } : null
        }) : /*#__PURE__*/React.createElement("div", {
          className: "video-container embed-responsive"
        }, /*#__PURE__*/React.createElement(YouTube, {
          videoId: new URLSearchParams(new URL(product[translateFieldName('video1')]).search).get('v'),
          opts: this.youtubeOptions
        }))), /*#__PURE__*/React.createElement("div", {
          className: "other-medias-container"
        }, /*#__PURE__*/React.createElement("div", {
          className: "other-medias"
        }, product.product_photos.map(function (photo, index) {
          return /*#__PURE__*/React.createElement("div", {
            key: photo.id,
            className: "image ".concat(_this2.state.activeSlide === index ? 'active' : ''),
            onClick: function onClick() {
              return _this2.setActiveSlide(index);
            },
            style: photo.photo.medium.url !== null ? {
              backgroundImage: "url(".concat(assetPath(photo.photo.medium.url), ")")
            } : null
          });
        }), product[translateFieldName('video1')] ? /*#__PURE__*/React.createElement("div", {
          onClick: function onClick() {
            return _this2.setActiveSlide(99);
          }
        }, /*#__PURE__*/React.createElement("img", {
          src: "https://img.youtube.com/vi/".concat(new URLSearchParams(new URL(product[translateFieldName('video1')]).search).get('v'), "/0.jpg"),
          alt: ""
        }), /*#__PURE__*/React.createElement("i", {
          className: "fa fa-play"
        })) : null)))), /*#__PURE__*/React.createElement("div", {
          className: "col-12 col-lg-6 py-3 product-description"
        }, /*#__PURE__*/React.createElement("div", {
          className: "container"
        }, /*#__PURE__*/React.createElement("div", {
          className: "box description-social ".concat(product[translateFieldName('msds')].url ? 'col-lg-4 col-md-4 col-sm-12' : 'col-lg-6 col-md-6 col-sm-12')
        }, /*#__PURE__*/React.createElement("span", {
          className: ""
        }, translate('Share', 'Partagez')), /*#__PURE__*/React.createElement(FacebookShareButton, {
          className: "social-icons",
          url: window.location.href
        }, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-facebook main-txt",
          "aria-hidden": "true"
        })), /*#__PURE__*/React.createElement(LinkedinShareButton, {
          className: "social-icons",
          url: window.location.href
        }, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-linkedin main-txt",
          "aria-hidden": "true"
        }))), /*#__PURE__*/React.createElement("div", {
          className: "description-title d-none d-lg-block"
        }, /*#__PURE__*/React.createElement("h1", {
          className: "uppercase"
        }, product[translateFieldName('code')]), /*#__PURE__*/React.createElement("div", {
          className: "dissan-codes uppercase"
        }, product.formats.map(function (format) {
          return /*#__PURE__*/React.createElement("span", {
            key: format.id,
            className: "item "
          }, format.code);
        })), /*#__PURE__*/React.createElement("h2", null, product[translateFieldName('name')])), /*#__PURE__*/React.createElement("div", {
          className: "description-add"
        }, product.formats.length > 0 && product.formats[0][translateFieldName('name')] !== '' ? /*#__PURE__*/React.createElement("div", {
          className: "add-box"
        }, /*#__PURE__*/React.createElement("div", {
          className: "format"
        }, /*#__PURE__*/React.createElement("span", null, product.variation[translateFieldName('name')].toUpperCase()), product.formats.length > 1 ? /*#__PURE__*/React.createElement("select", {
          ref: this.variationRef
        }, product.formats.map(function (format) {
          return /*#__PURE__*/React.createElement("option", {
            key: format.id,
            value: format.code
          }, format[translateFieldName('name')]);
        })) : /*#__PURE__*/React.createElement("div", null, product.formats[0][translateFieldName('name')]))) : null), /*#__PURE__*/React.createElement("div", {
          className: "buttons_bio"
        }, product[translateFieldName('msds')].url ? /*#__PURE__*/React.createElement("a", {
          href: API_URL + product[translateFieldName('msds')].url,
          target: "_blank",
          rel: "noopener noreferrer",
          className: "main-txt main-txt-hover uppercase ml-3 strong"
        }, translate('Consult SDS Sheet', 'Consulter la fiche FDS')) : null, /*#__PURE__*/React.createElement("a", {
          href: translate('/en/contact', '/contact'),
          target: "_blank",
          rel: "noopener noreferrer",
          className: "main-txt main-txt-hover uppercase ml-3 strong"
        }, translate('Contact', 'Nous Joindre'))), /*#__PURE__*/React.createElement("div", {
          className: "accordion",
          id: "accordionExample"
        }, product[translateFieldName('notifications')] ? /*#__PURE__*/React.createElement("div", {
          className: "card"
        }, /*#__PURE__*/React.createElement("div", {
          className: "card-header",
          id: "headingOne"
        }, /*#__PURE__*/React.createElement("h2", {
          className: "mb-0"
        }, /*#__PURE__*/React.createElement("button", {
          className: "btn btn-link btn-block text-left collapsed",
          type: "button",
          "data-toggle": "collapse",
          "data-target": "#collapseOne",
          "aria-expanded": "true",
          "aria-controls": "collapseOne"
        }, translate('features', 'avantages')))), /*#__PURE__*/React.createElement("div", {
          id: "collapseOne",
          className: "collapse",
          "aria-labelledby": "headingOne"
        }, /*#__PURE__*/React.createElement("div", {
          className: "card-body"
        }, /*#__PURE__*/React.createElement("ul", {
          className: "items-list"
        }, _compact(striptags(product[translateFieldName('notifications')], [], '&lt;br /&gt;').split('&lt;br /&gt;')).map(function (notification) {
          return notification !== '' ? /*#__PURE__*/React.createElement("li", {
            className: "d-flex align-items-center main-after",
            key: notification,
            dangerouslySetInnerHTML: {
              __html: notification
            }
          }) : null;
        }))))) : null, product.product_characteristics.length ? /*#__PURE__*/React.createElement("div", {
          className: "card"
        }, /*#__PURE__*/React.createElement("div", {
          className: "card-header",
          id: "headingTwo"
        }, /*#__PURE__*/React.createElement("h2", {
          className: "mb-0"
        }, /*#__PURE__*/React.createElement("button", {
          className: "btn btn-link btn-block text-left collapsed",
          type: "button",
          "data-toggle": "collapse",
          "data-target": "#collapseTwo",
          "aria-expanded": "false",
          "aria-controls": "collapseTwo"
        }, translate('Characteristics', 'Caractéristiques')))), /*#__PURE__*/React.createElement("div", {
          id: "collapseTwo",
          className: "collapse",
          "aria-labelledby": "headingTwo"
        }, /*#__PURE__*/React.createElement("div", {
          className: "card-body"
        }, _orderBy(product.product_characteristics, [function (characteristic) {
          return _deburr(characteristic.characteristic[translateFieldName('name')].toLowerCase());
        }]).map(function (characteristic) {
          return characteristic.characteristic[translateFieldName('name')] !== '' && characteristic[translateFieldName('value')] !== '' ? /*#__PURE__*/React.createElement("div", {
            key: characteristic.id,
            className: "item-features"
          }, /*#__PURE__*/React.createElement("div", {
            className: "second-bg-after"
          }, characteristic.characteristic[translateFieldName('name')]), /*#__PURE__*/React.createElement("span", null, characteristic[translateFieldName('value')])) : null;
        })))) : null))))), /*#__PURE__*/React.createElement("div", {
          className: "mobile-box"
        }, /*#__PURE__*/React.createElement(SingleProductMobileAccordion, {
          product: product
        })), /*#__PURE__*/React.createElement("div", {
          className: "description_container"
        }, /*#__PURE__*/React.createElement("div", {
          className: "container"
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
          className: "row single-product-moredesc d-none d-sm-none d-md-flex"
        }, /*#__PURE__*/React.createElement("div", {
          className: "col-12 col-lg-6 col-left"
        }, /*#__PURE__*/React.createElement("div", {
          className: "description-box mb-detailbox "
        }, product[translateFieldName('description')] !== null && product[translateFieldName('description')] !== '' ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
          className: "first-uppercase mobile-center main-bg-after"
        }, translate('full description', 'description complète')), /*#__PURE__*/React.createElement("p", {
          className: "first-uppercase",
          dangerouslySetInnerHTML: {
            __html: cleanHTML(product[translateFieldName('description')])
          }
        })) : null, product.pictos.length ? /*#__PURE__*/React.createElement("div", {
          className: "picto-box mobile-center"
        }, product.pictos.map(function (picto) {
          return picto[translateFieldName('description')] !== null ? /*#__PURE__*/React.createElement("img", {
            className: "pictos-box",
            key: picto.id,
            src: assetPath(picto.picto.url),
            alt: picto[translateFieldName('name')],
            title: picto[translateFieldName('description')].replace(new RegExp('<br />', 'g'), ' ')
          }) : /*#__PURE__*/React.createElement("img", {
            className: "pictos-box",
            key: picto.id,
            src: assetPath(picto.picto.url),
            alt: picto[translateFieldName('name')]
          });
        })) : null, product.certifications.length ? /*#__PURE__*/React.createElement("div", {
          className: "certifications-container"
        }, product.certifications.map(function (certification) {
          return /*#__PURE__*/React.createElement("img", {
            alt: certification[translateFieldName('name')],
            className: "certification-box",
            key: certification.id,
            src: assetPath(certification[translateFieldName('logo')].url),
            title: certification[translateFieldName('name')]
          });
        })) : null)), /*#__PURE__*/React.createElement("div", {
          className: "col-12 col-lg-6 col-right"
        }, product[translateFieldName('note')] !== '' && product[translateFieldName('note')] !== null ? /*#__PURE__*/React.createElement("div", {
          className: "dilution-box mb-detailbox mobile-center"
        }, product[translateFieldName('note_title')] !== '' ? /*#__PURE__*/React.createElement("h2", {
          className: "first-uppercase main-bg-after"
        }, product[translateFieldName('note_title')]) : null, /*#__PURE__*/React.createElement("ul", {
          className: "items-list"
        }, _compact(striptags(product[translateFieldName('note')], [], '&lt;br /&gt;').split('&lt;br /&gt;')).map(function (note) {
          return /*#__PURE__*/React.createElement("li", {
            className: "d-flex align-items-center main-after",
            key: note,
            dangerouslySetInnerHTML: {
              __html: note
            }
          });
        }))) : null, product[translateFieldName('product_file')].url || product[translateFieldName('other_pdf_name')] || product[translateFieldName('other_pdf_name2')] ? /*#__PURE__*/React.createElement("div", {
          className: "d-none d-sm-none d-md-block"
        }, /*#__PURE__*/React.createElement("h2", {
          className: "first-uppercase main-bg-after"
        }, translate('Description documents', 'Documents descriptifs')), /*#__PURE__*/React.createElement("div", {
          className: "documents-box mb-detailbox mobile-center"
        }, product[translateFieldName('product_file')].url ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
          className: "fa mr-2 fa-file-pdf-o main-txt",
          "aria-hidden": "true"
        }), /*#__PURE__*/React.createElement("a", {
          href: API_URL + product[translateFieldName('product_file')].url,
          target: "_blank",
          rel: "noopener noreferrer",
          className: "main-txt main-txt-hover small strong"
        }, translate('Product sheet', 'Fiche produit'))) : null, product[translateFieldName('other_pdf')].url ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
          className: "fa mr-2 fa-file-pdf-o main-txt",
          "aria-hidden": "true"
        }), /*#__PURE__*/React.createElement("a", {
          href: API_URL + product[translateFieldName('other_pdf')].url,
          target: "_blank",
          rel: "noopener noreferrer",
          className: "main-txt main-txt-hover small strong"
        }, product[translateFieldName('pdf_name')] !== '' ? product[translateFieldName('pdf_name')] : 'Document')) : null, product[translateFieldName('other_pdf2')].url ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
          className: "fa mr-2 fa-file-pdf-o main-txt",
          "aria-hidden": "true"
        }), /*#__PURE__*/React.createElement("a", {
          href: API_URL + product[translateFieldName('other_pdf2')].url,
          target: "_blank",
          rel: "noopener noreferrer",
          className: "main-txt main-txt-hover small strong"
        }, product[translateFieldName('other_pdf_name')])) : null)) : null)))), /*#__PURE__*/React.createElement("div", {
          className: "find-distributor"
        }, /*#__PURE__*/React.createElement("div", {
          className: "container distributor"
        }, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-map-marker",
          "aria-hidden": "true"
        }), /*#__PURE__*/React.createElement("div", {
          className: "form-distributor"
        }, /*#__PURE__*/React.createElement("h4", {
          className: "form-distributor-title"
        }, translate('find a distributor', 'trouver un distributeur')), /*#__PURE__*/React.createElement("form", {
          action: "/".concat(LANG, "/").concat(translate('distributer-ino', 'distributeur-ino'), "/#distributer"),
          method: "POST"
        }, /*#__PURE__*/React.createElement("div", {
          className: "form-row"
        }, /*#__PURE__*/React.createElement("div", {
          className: "col-md-4 mb-3"
        }, /*#__PURE__*/React.createElement("label", null, "Adresse", /*#__PURE__*/React.createElement("input", {
          name: "address",
          type: "text",
          className: "form-control",
          id: "validationDefault03",
          required: true,
          placeholder: translate('City, Province or Postal code', 'Ville, Province ou Code postal')
        }))), /*#__PURE__*/React.createElement("div", {
          className: "col-md-3 mb-3"
        }, /*#__PURE__*/React.createElement("label", null, "Rayon", /*#__PURE__*/React.createElement("select", {
          name: "ray",
          className: "custom-select",
          id: "validationDefault04",
          required: true
        }, /*#__PURE__*/React.createElement("option", {
          value: "25"
        }, "25 km"), /*#__PURE__*/React.createElement("option", {
          value: "55"
        }, "55 km"), /*#__PURE__*/React.createElement("option", {
          value: "65"
        }, "65 km")))), /*#__PURE__*/React.createElement("button", {
          className: "btn btn-primary",
          type: "submit"
        }, translate('research', 'recherche'), " ", /*#__PURE__*/React.createElement("i", {
          className: "fa fa-search",
          "aria-hidden": "true"
        }))))))), /*#__PURE__*/React.createElement("div", {
          className: "container suggestion_container"
        }, suggestionProducts.length ? /*#__PURE__*/React.createElement("div", {
          className: "related-compatible-products"
        }, /*#__PURE__*/React.createElement("div", {
          className: "related-products-container"
        }, /*#__PURE__*/React.createElement("div", {
          className: "row mobile-center"
        }, /*#__PURE__*/React.createElement("div", {
          className: "col-12 other-items-bottom"
        }, /*#__PURE__*/React.createElement("h2", {
          className: "uppercase main-bg-after"
        }, translate('Other Suggestions', 'Autres Suggestions')))), /*#__PURE__*/React.createElement("div", {
          className: "row suggestion_container"
        }, /*#__PURE__*/React.createElement(SuggestionProducts, {
          products: suggestionProducts,
          setActiveProduct: this.setActiveProduct
        })))) : null)));
      } else {
        return null;
      }
    }
  }]);

  return SingleProductWoMatch;
}(Component);

SingleProductWoMatch.propTypes = {
  addToCart: PropTypes.func,
  history: PropTypes.object,
  product: PropTypes.object,
  slug: PropTypes.string,
  match: PropTypes.object,
  rootElement: PropTypes.string
};
export default SingleProductWoMatch;